import React from 'react';
import PropTypes from 'prop-types';

const RequiredLabel = ({ text = '', htmlFor = '', className = '', children }) => {
  return (
    <label htmlFor={htmlFor} className={className}>
      {text || children} <span className="text-gray-900">*</span>
    </label>
  );
};

RequiredLabel.propTypes = {
  text: PropTypes.string,
  htmlFor: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.element
};

export default RequiredLabel;
